export default __webpack_public_path__ + "static/media/640_dummy2016-heimtier01-de.5de58727.png";